import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      <footer>
        This app has been built by{" "}
        <a href="https://github.com/Kumaguro3/weather-react">Sergent Julie</a>
      </footer>
    </div>
  );
}
